export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-music-53fc21ff1d3574d23d2ea49149ecc0d9.svg";